<script>
import { enumValidator } from "../enumValidator";
import { mergeData } from "vue-functional-data-merge";

export default {
  functional: true,
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: enumValidator(["half", "1", "2", "3", "4", "5", "6"]),
      default: "1"
    }
  },
  render: function(createElement, context) {
    const { props, data, children } = context;

    return createElement(
      "div",
      mergeData(data, {
        class: [
          "am-spacing",
          `am-spacing--size-${props.size}`,
          {
            "am-spacing--inline": props.inline,
            "am-spacing--block": !props.inline
          }
        ]
      }),
      children
    );
  }
};
</script>
